import React from 'react';
import { Link } from 'react-router-dom';

const AdminIndex: React.FC = () => {
  // Background image URL
  const BG_IMAGE = "https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=2072&auto=format&fit=crop"; // Tech/Space/Network abstract

  return (
    <div
      className="min-h-screen relative flex flex-col font-sans text-gray-900"
      style={{
        backgroundImage: `url(${BG_IMAGE})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Dark overlay for readability */}
      <div className="absolute inset-0 bg-black/20" />

      {/* Top Navigation Bar */}
      <nav className="relative z-10 w-full px-6 py-4 flex justify-center items-center">
        <div className="flex items-center space-x-2 px-4 py-2">
          <img
            src="/Scubamal logo for black bg.png"
            alt="Scubamail Logo"
            className="h-8 w-auto object-contain"
          />
        </div>
      </nav>

      {/* Main Content Area */}
      <div className="relative z-10 flex-1 flex items-center justify-center p-4 sm:p-6 lg:p-8">
        <div className="w-full max-w-4xl mx-auto text-center">

          <div className="mb-12 space-y-4">
            <h1 className="text-5xl md:text-7xl font-bold tracking-tight text-white drop-shadow-lg">
              Scubamail Admin
            </h1>
            <p className="text-xl text-gray-200 max-w-2xl mx-auto leading-relaxed drop-shadow-md">
              Secure access to the core of your email marketing platform. Manage users, monitor systems, and oversee operations.
            </p>
          </div>

          <div className="flex justify-center">
            <div className="bg-white/20 backdrop-blur-xl border border-white/30 rounded-3xl p-10 shadow-2xl max-w-md w-full relative overflow-hidden group hover:bg-white/25 transition-all duration-300">
              {/* Card glossy reflection effect */}
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-white/50 to-transparent opacity-50"></div>

              <div className="mb-8">
                <div className="mx-auto w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mb-6 border border-white/30 group-hover:scale-110 transition-transform duration-300">
                  <span className="text-4xl">🔐</span>
                </div>
                <h2 className="text-2xl font-bold text-white mb-2">Restricted Access</h2>
                <p className="text-gray-200 text-sm">Authorized personnel only</p>
              </div>

              <Link
                to="/admin/login"
                className="block w-full py-4 px-6 bg-black text-white font-bold rounded-full hover:bg-gray-900 transition-all duration-300 shadow-lg transform active:scale-95"
              >
                Sign In to Portal
              </Link>
            </div>
          </div>

          <p className="mt-12 text-sm text-gray-300/80 max-w-lg mx-auto">
            System activities are logged. Unauthorized access attempts will be reported.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminIndex;
